import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  overflow: hidden;\n  position: relative;\n\n  &:before,\n  &:after {\n    content: '';\n    height: 100%;\n    width: 10px;\n    position: absolute;\n    top: 0;\n    transition: 0.2s opacity;\n    pointer-events: none;\n  }\n\n  &:before {\n    left: 0;\n    background: linear-gradient(90deg, rgba(247, 248, 250, 0), transparent);\n    opacity: ",
        ";\n    z-index: 1;\n  }\n\n  &:after {\n    right: 0;\n    background: linear-gradient(270deg, rgba(247, 248, 250, 1), transparent);\n    opacity: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  overflow-x: auto;\n  width: auto;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useScroll } from "framer-motion";
import { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useDebouncedCallback } from "use-debounce";
const ShadowWrapper = styled.div.withConfig({
    componentId: "sc-f8a070c5-0"
})(_templateObject(), (props)=>props.opacityLeft, (props)=>props.opacityRight);
const ShadowScroller = styled.div.withConfig({
    componentId: "sc-f8a070c5-1"
})(_templateObject1());
const ShadowSlideContainer = (param)=>{
    let { children  } = param;
    const wrapperShadowRef = useRef();
    const { scrollXProgress  } = useScroll({
        container: wrapperShadowRef
    });
    const [transparencies, setTransparencies] = useState({
        opacityLeft: 0,
        opacityRight: 0
    });
    const setup = useCallback((progress)=>{
        const { current: wrapperShadow  } = wrapperShadowRef;
        let newValues = {
            opacityLeft: 0,
            opacityRight: 0
        };
        if (wrapperShadow && wrapperShadow.offsetWidth < wrapperShadow.scrollWidth) {
            newValues.opacityLeft = progress === 0 ? 0 : 1;
            newValues.opacityRight = progress === 1 ? 0 : 1;
        // newValues.opacityLeft = progress
        // newValues.opacityRight = 1 - progress
        }
        // console.log(
        // 	wrapperShadow.offsetWidth,
        // 	wrapperShadow.scrollWidth,
        // 	newValues.opacityLeft,
        // 	newValues.opacityRight,
        // )
        setTransparencies(newValues);
    }, []);
    const debouncedSetup = useDebouncedCallback(setup, 50);
    useEffect(()=>{
        function handleChange() {
            debouncedSetup(scrollXProgress.get());
        }
        const unsubscribe = scrollXProgress.on("change", handleChange);
        handleChange();
        return ()=>{
            unsubscribe();
        };
    }, [
        debouncedSetup
    ]);
    return /*#__PURE__*/ _jsx(ShadowWrapper, {
        ...transparencies,
        children: /*#__PURE__*/ _jsx(ShadowScroller, {
            ref: wrapperShadowRef,
            children: children
        })
    });
};
export default ShadowSlideContainer;
